import { render } from "./MegaMenu.vue?vue&type=template&id=7066787a"
import script from "./MegaMenu.vue?vue&type=script&lang=js"
export * from "./MegaMenu.vue?vue&type=script&lang=js"

import "./MegaMenu.vue?vue&type=style&index=0&id=7066787a&lang=css"
script.render = render

export default script